import { createRoute } from "@tanstack/react-router";
import { requirePermissions } from "@/app/guards";
import { DESIGNER_PERMISSIONS, TEMPLATES_PERMISSIONS } from "@/app/nav";
import { TemplateDetailPage } from "@/features/templates/TemplateDetailPage";
import { TemplateLibrary } from "@/features/templates/TemplateLibrary";
import { TemplateDesignerPage } from "@/features/templates/designer/TemplateDesignerPage";
import { staffRoute } from "@/routes/staff";

/** preview is the version shown; signature and batch are what it is rendered with. */
export type TemplateDetailSearch = { preview?: string; signature?: string; batch?: string };

/** field is the index of the selected field in the definition's fields. */
export type TemplateDesignerSearch = { field?: number };

const nonEmpty = (value: unknown) => (typeof value === "string" && value.trim() !== "" ? value.trim() : undefined);

export const templatesRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "templates",
  beforeLoad: ({ context }) => requirePermissions(context.session, TEMPLATES_PERMISSIONS),
  component: TemplateLibrary,
});

export const templateDetailRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "templates/$templateId",
  // Set, never omit, each key: the router merges this over the raw query string.
  validateSearch: (search: Record<string, unknown>): TemplateDetailSearch => ({
    preview: nonEmpty(search.preview),
    signature: nonEmpty(search.signature),
    batch: nonEmpty(search.batch),
  }),
  beforeLoad: ({ context }) => requirePermissions(context.session, TEMPLATES_PERMISSIONS),
  component: TemplateDetailPage,
});

const index = (value: unknown) => {
  const n = typeof value === "number" ? value : typeof value === "string" && value.trim() !== "" ? Number(value) : NaN;
  return Number.isInteger(n) && n >= 0 ? n : undefined;
};

export const templateDesignerRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "templates/$templateId/versions/$versionId/edit",
  validateSearch: (search: Record<string, unknown>): TemplateDesignerSearch => ({ field: index(search.field) }),
  beforeLoad: ({ context }) => requirePermissions(context.session, DESIGNER_PERMISSIONS),
  component: TemplateDesignerPage,
});
